import { Module } from 'vuex';
import { RootState } from '@/app/app.store';
import { apiHttpClient } from '@/app/app.service';

export interface InviteValidateResult {
  id: string;
  userId: string | null;
  expiredAt: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  version: number;
}

export interface InviteValidateStoreState {
  isValidInviteCode: boolean;
  inviteCode: string;
  inviteValidateResult: InviteValidateResult | null;
  loading: boolean;
}

export interface ValidateInviteOptions {
  inviteCode: string;
}

export const inviteValidateStoreModule: Module<
  InviteValidateStoreState,
  RootState
> = {
  /**
   * 命名空间
   */
  namespaced: true,

  /**
   * 数据
   */
  state: {
    isValidInviteCode: false,
    inviteCode: '',
    inviteValidateResult: null,
    loading: false,
  } as InviteValidateStoreState,

  /**
   * 获取器
   */
  getters: {
    isValidInviteCode(state) {
      return state.isValidInviteCode;
    },

    inviteCode(state) {
      return state.inviteCode;
    },

    inviteValidateResult(state) {
      return state.inviteValidateResult;
    },

    loading(state) {
      return state.loading;
    },
  },

  /**
   * 修改器
   */
  mutations: {
    setIsValidInviteCode(state, data) {
      state.isValidInviteCode = data;
    },

    setInviteCode(state, data) {
      state.inviteCode = data;
    },

    setInviteValidateResult(state, data) {
      state.inviteValidateResult = data;
    },

    setLoading(state, data) {
      state.loading = data;
    },
  },

  /**
   * 动作
   */
  actions: {
    async validateInvite({ commit }, options: ValidateInviteOptions) {
      commit('setLoading', true);
      const { inviteCode } = options;

      try {
        const response = await apiHttpClient.post(
          `/invites/${inviteCode}/validate`,
        );

        commit('setInviteValidateResult', response.data);
        commit('setIsValidInviteCode', true);
        commit('setLoading', false);

        return response;
      } catch (error) {
        commit('setIsValidInviteCode', false);
        commit('setLoading', false);

        throw error.response;
      }
    },
  },

  /**
   * 模块
   */
  modules: {},
};
